module.exports = __webpack_public_path__ + "static/media/coriandoliBackground.c5dc8788.png";